<app-header></app-header>
<app-page-title></app-page-title>

<div class="page-container">

  <!-- Page content -->
  <div class="page-content">

    <!-- Main content -->
    <div class="content-wrapper">

      <div class="row">

        <div class="panel panel-flat">
          <div class="panel-heading">
            <h5 class="panel-title">Archived Industry</h5>

            <div class="heading-elements">
              <ul class="icons-list">
                <li>
                  <button style="margin-right: 10px; cursor: pointer !important;" type="button" class="btn btn-xs btn-info"><strong>Total Archived Industry </strong>  <span class="badge badge-info">{{allIndustriesDetails.length}}</span></button>
                </li>

                <li>
                  <a title="Export Excel." (click)="exportReport('excel')" style="background-color: #EEF3F6; font-weight: 900 !important; color: #000 !important; margin-right: 10px;" class="btn border-primary text-primary btn-flat btn-icon btn-rounded btn-sm">
                    <i class="icon icon-file-excel"></i>
                  </a>
                </li>
                <a id="exportexcelhref" target="_blank"></a>

                <li>
                  <a title="Export PDF." (click)="exportReport('pdf')" style="background-color: #EEF3F6; font-weight: 900 !important; color: #000 !important; margin-right: 10px;" class="btn border-primary text-primary btn-flat btn-icon btn-rounded btn-sm">
                    <i class="icon icon-file-pdf"></i>
                  </a>
                  <a id="exportpdfhref" target="_blank"></a>
                </li>

                <li>
                  <select [(ngModel)]="searchField.emmisionType" (change)="getAllIndustryDetails()" class="form-control">
                    <option value=""> Select Monitoring Type </option>
                    <option value="air">Air Emission</option>
                    <option value="water">Water Effluent </option>
                    <option value="both">Air & Water</option>
                  </select>
                </li>
              </ul>

            </div>

          </div>
          <div class="table-responsive">
            <table class="table datatable-show-all">
              <thead>
              <tr>
                <th *ngIf="state == 'Delhi'" style="" >S.No</th>
                <th style="">Industry Name</th>
                <th style="">Industry ID in OCMMS</th>
                <th style="">Vendor Name</th>
                <th style="">Industry Address</th>
                <th style="">District</th>
                <th *ngIf="state != 'Delhi'" style="">Region</th>
                <!--<th style="">Sub Region</th>-->
                <th style="">Category Type</th>
                <th style="">Category of Industry</th>
                <!--<th style="">Name of Category</th>-->
                <th style="">Initially Connected On</th>
                <th style="">Last Data Received</th>
                <th style="">Connection status</th>
                <th style="" class="text-center">Action</th>
              </tr>
              <tr>
                <th *ngIf="state == 'Delhi'" style=" padding: 4px;"></th>
                <th style=" padding: 4px;">
                  <input autocomplete="off" pattern="^[^<>]*$" [(ngModel)]="searchField.industryName" (keyup)="getAllIndustryDetails()" type="text" class="form-control" placeholder="Search by Name"></th>
                <th style=" padding: 4px;">
                  <input autocomplete="off" pattern="^[^<>]*$" *ngIf="userLevel != 'industry'" [(ngModel)]="searchField.industryId" type="text" class="form-control" (keyup)="getAllIndustryDetails()" placeholder="Search by ID">
                </th>
                <th style=" padding: 4px;">
                  <!--<input *ngIf="userLevel != 'vendor'" [(ngModel)]="searchField.vendorName" type="text" class="form-control" (keyup)="getAllIndustryDetails()" placeholder="Search by Vendor Name">-->

                  <input autocomplete="off" pattern="^[^<>]*$" [(ngModel)]="searchField.vendorName" *ngIf="userLevel != 'vendor'" class="form-control" list="vendorList" (keyup)="getAllIndustryDetails()" placeholder="Search by Vendor Name">
                  <datalist id="vendorList">
                    <option *ngFor="let vendor of vendorList" value="{{vendor.vendor_short_name}}">
                  </datalist>
                </th>
                <th style=" padding: 4px;"><input autocomplete="off" pattern="^[^<>]*$" [(ngModel)]="searchField.address" type="text" class="form-control" (keyup)="getAllIndustryDetails()" placeholder="Search by Address"></th>
                <th style=" padding: 4px;">
                  <!--<input [(ngModel)]="searchField.district" type="text" class="form-control" (keyup)="getAllIndustryDetails()" placeholder="Search by District">-->
                  <select [(ngModel)]="searchField.district" (change)="getAllIndustryDetails()" class="form-control">
                    <option value=""> Select District </option>
                    <option value="{{cityRow.city}}" *ngFor="let cityRow of allCityList"> {{cityRow.city}} </option>
                  </select>
                </th>
                <th *ngIf="state != 'Delhi'" style=" padding: 4px;">
                  <select [(ngModel)]="searchField.region" (change)="getAllIndustryDetails()" class="form-control">
                    <option value=""> Select Region </option>
                    <option *ngFor="let regionRow of regionList"  value="{{regionRow.region_name}}"> {{regionRow.region_name}} </option>
                  </select>
                </th>
                <!--<th style=" padding: 4px;"><input [(ngModel)]="searchField.subRegion" type="text" class="form-control" (keyup)="getAllIndustryDetails()" placeholder="Search by Name"></th>-->
                <th style=" padding: 4px;">
                  <input autocomplete="off" pattern="^[^<>]*$" [(ngModel)]="searchField.categoryType" type="text" class="form-control" (keyup)="getAllIndustryDetails()" placeholder="Search by Category Type">
                </th>
                <th style=" padding: 4px;"><input autocomplete="off" pattern="^[^<>]*$" [(ngModel)]="searchField.indCategory" type="text" class="form-control" (keyup)="getAllIndustryDetails()" placeholder="Search by Industry Category"></th>
                <!--<th>Name of Category</th>-->
                <th style=" padding: 4px;"></th>
                <th style=" padding: 4px;"></th>
                <th style=" padding: 4px;">
                  <!--<input  type="text" class="form-control"  placeholder="Search by Status">-->
                  <select [(ngModel)]="searchField.status" (change)="getAllIndustryDetails()" class="form-control">
                    <option value=""> Select Status </option>
                    <option value="online"> Online </option>
                    <option value="offline"> Offline </option>
                    <option value="delay"> Delay </option>
                    <!--<option value="under maintenance"> Under Maintenance </option>-->
                    <!--<option value="closed"> Closed by CPCB/HSPCB </option>-->
                  </select>
                </th>
                <th style=" padding: 4px;" class="text-center"></th>
              </tr>
              </thead>

              <tbody *ngIf="!industryListLoader &&  allIndustriesDetails.length">
              <tr *ngFor="let industry of allIndustriesDetails let i = index" [attr.data-index]="i">
                <td *ngIf="state == 'Delhi'"> {{i + 1}} </td>
                <td style="text-transform: capitalize;" title="{{industry.name}}"><a [routerLink]="['/industry']" [queryParams]="{industry_id: industry.id | base64:'encode', archive:true}">
                  {{(industry.name.length>40)? (industry.name | slice:0:40)+'...':(industry.name)}}
                </a></td>
                <td title="{{industry.hr_ocmms_id}}">
                  <span *ngIf="industry.hr_ocmms_id">{{ (industry.hr_ocmms_id.length>10)? ((industry.hr_ocmms_id | slice:0:10)+'...'):(industry.hr_ocmms_id) }}</span>
                  <span *ngIf="!industry.hr_ocmms_id">{{industry.hr_ocmms_id}}</span>
                  <!--{{industry.hr_ocmms_id}}-->
                </td>
                <td title="{{industry.vendors}}" style="text-transform: capitalize;">
                  {{ (industry.vendors.length>10)? ((industry.vendors | slice:0:10)+'...'):(industry.vendors) }}
                </td>
                <td  style="word-break: break-all; " title="{{industry.address}}">{{(industry.address.length>50)? (industry.address | slice:0:50)+'...':(industry.address)}}</td>

                <td style="word-break: break-all;">{{industry.city}}</td>
                <td *ngIf="state != 'Delhi'" style="word-break: break-all;">
                  {{industry.region_name}}
                </td>

                <td style="word-break: break-all;">{{industry.industry_category}}</td>
                <td title="{{industry.industry_type}}" style="word-break: break-all;">
                  {{ (industry.industry_type.length>10)? ((industry.industry_type | slice:0:10)+'...'):(industry.industry_type) }}
                </td>
                <td>
                  <div style="margin-bottom: 5px;" class="label label-primary">{{industry.created_date | date: 'dd/MM/yyyy' }}</div>
                  <div class="label label-primary">{{industry.created_date | date: 'H:mm' }}</div>
                </td>
                <td>
                  <div style="margin-bottom: 5px;" class="label label-primary">{{industry.last_update_date | date: 'dd/MM/yyyy' }}</div>
                  <div class="label label-primary">{{industry.last_update_date?(industry.last_update_date | date: 'H:mm'):'No Data' }}</div>
                </td>
                <td>
                  <span *ngIf="(industry.last_update_date | industryStatus) == 'Delay'" class="label label-warning">{{industry.last_update_date | industryStatus}}</span>
                  <span *ngIf="(industry.last_update_date | industryStatus) == 'Online'" class="label label-success"><strong>{{industry.last_update_date | industryStatus}}</strong></span>
                  <span *ngIf="(industry.last_update_date | industryStatus) == 'Offline'" class="label label-danger">{{industry.last_update_date | industryStatus}}</span>
                </td>

                <td class="text-center">
                  <!--<td class="text-center">-->
<!--                  <ul class="icons-list">-->
<!--                    <li class="dropdown">-->
<!--                      <a class="dropdown-toggle" data-toggle="dropdown">-->
<!--                        <i class="icon-menu9"></i>-->
<!--                      </a>-->

<!--                      <ul class="dropdown-menu dropdown-menu-right">-->
<!--                        <li title="View Industry Analytics" style="cursor: not-allowed;"><a [routerLink]="['/industry']" [queryParams]="{industry_id: industry.id | base64:'encode', archive:true}"><i class="icon icon-graph"></i> View Analytics</a></li>-->
<!--                        <li title="View Industry Information" style="cursor: not-allowed;"><a [routerLink]="['/industry-edit']" [queryParams]="{industry_id: industry.id | base64:'encode', type: 'view' | base64:'encode', archive:true}"><i class="icon icon-eye4"></i> View Info.</a></li>-->
<!--&lt;!&ndash;                        <li *ngIf="userLevel == 'admin' || userName == 'HSPCBCEMS' || production == false" title="Update Industry Details" style="cursor: not-allowed;"><a [routerLink]="['/industry-edit']" [queryParams]="{industry_id: industry.id | base64:'encode',type: 'edit' | base64:'encode'}"><i class="icon icon-loop3"></i> Update Details</a></li>&ndash;&gt;-->
<!--&lt;!&ndash;                        <li *ngIf="userLevel == 'admin' || userName == 'HSPCBCEMS'" title="Delete Industry"><a (click)="deleteIndustry(industry.id)"><i class="icon icon-bin"></i> Delete</a></li>&ndash;&gt;-->

<!--                        &lt;!&ndash;<li title="Update Industry Details" style="cursor: not-allowed;"><a [routerLink]="['/industry-edit']" [queryParams]="{industry_id: industry.id | base64:'encode',type: 'edit' | base64:'encode'}"><i class="icon icon-loop3"></i> Update Details</a></li>&ndash;&gt;-->
<!--                        &lt;!&ndash;<li title="Delete Industry"><a (click)="deleteIndustry(industry.id)"><i class="icon icon-bin"></i> Delete</a></li>&ndash;&gt;-->
<!--                      </ul>-->
<!--                    </li>-->
<!--                  </ul>-->
                  <ul class="icons-list">
                    <li class="dropdown">
                      <a class="dropdown-toggle" data-bs-toggle="dropdown">
                        <i class="icon-menu9"></i> &#9662;
                      </a>

                      <ul class="dropdown-menu dropdown-menu-end">
                        <li title="View Industry Analytics" style="cursor: not-allowed;">
                          <a class="dropdown-item" [routerLink]="['/industry']" [queryParams]="{industry_id: industry.id | base64:'encode', archive:true}">
                            <i class="icon icon-graph"></i> View Analytics
                          </a>
                        </li>
                        <li title="View Industry Information" style="cursor: not-allowed;">
                          <a class="dropdown-item" [routerLink]="['/industry-edit']" [queryParams]="{industry_id: industry.id | base64:'encode', type: 'view' | base64:'encode', archive:true}">
                            <i class="icon icon-eye4"></i> View Info.
                          </a>
                        </li>
                        <!-- Additional items can be added here if needed -->
                      </ul>
                    </li>
                  </ul>

                </td>
                <!--<td class="text-center">-->
                <!--<button class="btn btn-xs" style="padding: 5px; padding-left: 10px; padding-right: 10px; background-color: #38B2F7;" title="More detail">-->
                <!--<a style="color: #fff;" [routerLink]="['/industry']" [queryParams]="{industry_id: industry.id}"><i class="icon-more2"></i></a>-->
                <!--</button>-->
                <!--</td>-->
              </tr>
              </tbody>

              <tbody *ngIf="!industryListLoader && !allIndustriesDetails.length" >
              <tr>
                <td colspan="12" class="col-lg-12 text-center" style="height: 180px;">
                  <div class="label label-danger" style="margin-top: 50px;">No Industry Found</div>
                </td>
              </tr>
              </tbody>

              <tbody *ngIf="industryListLoader" >
              <tr>
                <td colspan="12" class="col-lg-12 text-center" style="height: 180px;">
                  <div style="margin-top: 50px;">
                    <img src="/assets/images/load.gif" />
                  </div>
                </td>
              </tr>
              </tbody>

            </table>
          </div>
        </div>


      </div>

    </div>
  </div>
</div>

<app-footer></app-footer>
